import React from 'react';

import { MeButton } from './styles';

export interface IProps {
  disabled?: boolean;
  id?: number;
  onClick?: () => void;
  children: any;
  type?: 'button' | 'submit' | 'reset' | undefined;
  margin?: string;
  padding?: string;
  style?: object;
  noMin?: boolean;
}

const Button: React.FC<any> = ({ disabled, onClick, children, type, margin, padding, style, noMin, id }) => {
  return (
    <MeButton
      style={style}
      id={id ? `${`${id}`}` : 'btnViagem_0'}
      disabled={disabled}
      onClick={onClick}
      type={type}
      margin={margin}
      padding={padding}
      noMin={noMin}
    >
      {children}
    </MeButton>
  );
};

export default Button;
